Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AirmojiPropType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Libraries

// Stylesheet


var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

var _airmojiConstants = require('../constants/airmojiConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AirmojiPropType = exports.AirmojiPropType = _propTypes2['default'].oneOf(Object.keys(_airmojiConstants.AIRMOJI_MAPPING));

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  name: AirmojiPropType.isRequired,
  accessibilityLabel: _propTypes2['default'].string
}));

// Components
function Airmoji(_ref) {
  var css = _ref.css,
      name = _ref.name,
      styles = _ref.styles,
      accessibilityLabel = _ref.accessibilityLabel;

  var airmoji = _airmojiConstants.AIRMOJI_MAPPING[name];
  return _react2['default'].createElement(
    'span',
    _extends({}, css(styles.airmoji), {
      'aria-label': accessibilityLabel,
      'aria-hidden': !accessibilityLabel
    }),
    airmoji
  );
}

Airmoji.componentCategory = 'Core';
Airmoji.displayName = 'Airmoji';
Airmoji.propTypes = propTypes;

exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
  var font = _ref2.font;
  return {
    airmoji: font.airmoji
  };
})(Airmoji);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Airmoji.js
// module id = 243
// module chunks = 168707334958949